export const getErrorMessage = (error: any, keys: string[] = []):string => {
  if (!error) return 'Unknown error'

  if (typeof error === 'string') return error;

  for (const key of keys) {
    if (key in error && typeof error[key] === 'string') return error[key] as string
  }

  if (error.message) return error.message
  if (error.name) return error.name

  return JSON.stringify(error)
}
